import { PageHero } from "../components/sections";
import { Reveal } from "../components/common";
import Seo from "../components/Seo";
import { IMAGES, COMPANY } from "../data/site";

const CONTENT = {
  "mentions-legales": {
    eyebrow: "Informations légales",
    title: "Mentions légales",
    sub: "Informations relatives à l'éditeur et à l'hébergement du site.",
    sections: [
      {
        h: "Éditeur du site",
        p: `Le présent site est édité par ${COMPANY.name}, conciergerie et entreprise de ménage pour locations saisonnières basée à ${COMPANY.city}. Téléphone : ${COMPANY.phone}.`,
      },
      {
        h: "Responsable de publication",
        p: "Le responsable de la publication est la direction de Groupe Cleanova - Sud. Pour toute demande, contactez-nous via le formulaire de contact ou par téléphone.",
      },
      {
        h: "Hébergement",
        p: "Le site est hébergé par un prestataire d'hébergement web professionnel. Les coordonnées complètes de l'hébergeur peuvent être communiquées sur simple demande.",
      },
      {
        h: "Propriété intellectuelle",
        p: "L'ensemble des contenus présents sur ce site (textes, images, logo, charte graphique) est la propriété de Groupe Cleanova - Sud, sauf mention contraire. Toute reproduction sans autorisation est interdite.",
      },
    ],
  },
  cgv: {
    eyebrow: "Conditions",
    title: "Conditions Générales de Vente",
    sub: "Les conditions régissant nos prestations de ménage et de conciergerie.",
    sections: [
      {
        h: "Objet",
        p: "Les présentes conditions générales de vente régissent les prestations de ménage, de conciergerie et les services associés proposés par Groupe Cleanova - Sud à ses clients propriétaires et gestionnaires.",
      },
      {
        h: "Prestations et tarifs",
        p: "Les tarifs dépendent de la surface du logement, du nombre de lits, de la fréquence et des options choisies (linge, lits faits, consommables, paniers d'accueil). Un devis personnalisé est établi avant toute intervention.",
      },
      {
        h: "Réservation et paiement",
        p: "Toute prestation fait l'objet d'une confirmation préalable. Les modalités de paiement sont précisées sur le devis. Les paniers d'accueil peuvent être réglés en ligne.",
      },
      {
        h: "Annulation",
        p: "Toute annulation doit être communiquée dans les meilleurs délais afin de permettre la réorganisation du planning. Les conditions d'annulation sont précisées au moment de la réservation.",
      },
    ],
  },
  "politique-de-confidentialite": {
    eyebrow: "Vie privée",
    title: "Politique de confidentialité",
    sub: "La manière dont nous collectons et protégeons vos données personnelles.",
    sections: [
      {
        h: "Données collectées",
        p: "Nous collectons uniquement les données nécessaires au traitement de votre demande : nom, email, téléphone, ville, type de bien et message. Ces données sont transmises via notre formulaire de contact.",
      },
      {
        h: "Utilisation des données",
        p: "Vos données sont utilisées exclusivement pour répondre à votre demande, établir un devis et assurer le suivi de nos prestations. Elles ne sont jamais revendues à des tiers.",
      },
      {
        h: "Conservation",
        p: "Vos données sont conservées pendant la durée nécessaire au traitement de votre demande et de la relation commerciale, conformément à la réglementation en vigueur (RGPD).",
      },
      {
        h: "Vos droits",
        p: `Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ces droits, contactez-nous au ${COMPANY.phone}.`,
      },
    ],
  },
};

export default function Legal({ type }) {
  const data = CONTENT[type];
  if (!data) return null;
  return (
    <div data-testid={`legal-${type}`}>
      <Seo
        title={`${data.title} | Cleanova-Sud`}
        description={data.sub}
        path={`/contact/${type}`}
      />
      <PageHero eyebrow={data.eyebrow} title={data.title} sub={data.sub} image={IMAGES.coastNight} />
      <section className="section">
        <div className="container-x max-w-3xl">
          {data.sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 60}>
              <div className="mb-10">
                <h2 className="font-display text-3xl">{s.h}</h2>
                <p className="mt-3 leading-relaxed" style={{ color: "var(--muted)" }}>{s.p}</p>
              </div>
            </Reveal>
          ))}
          <p className="text-sm mt-4" style={{ color: "var(--muted)" }}>
            Dernière mise à jour : {new Date().getFullYear()}. Pour toute question, contactez-nous au {COMPANY.phone}.
          </p>
        </div>
      </section>
    </div>
  );
}
